/*
 * Copyright (c) Worldline 2023.
 */

import {Component, Input, OnChanges} from '@angular/core';
import * as $ from 'jquery';
import {HttpClient} from "@angular/common/http";
import {DatePipe} from "@angular/common";
import * as ldapjs from 'ldapjs';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {CertificatePopupComponent} from "../certificate-popup/certificate-popup.component";
import {NgxSpinnerService} from "ngx-spinner";
import {SbxEvents} from "../../constant/sbx-events";
import {SharedService} from "../../services/shared.service";

@Component({
    selector: 'pdf-viewer',
    templateUrl: './pdf-viewer.component.html'
})
export class PdfViewerComponent implements OnChanges {

    constructor(private http: HttpClient, private datePipe: DatePipe, private modalService: NgbModal, private spinnerService: NgxSpinnerService, private shared: SharedService) {
    }

    // Inputs required
    /**
     * The pdf name for download button
     */
    @Input()
    pdfName: string = '';
    /**
     * The pdf url to download
     */
    @Input()
    downloadUrl: string = '';
    /**
     * The url to retrieve signature info
     */
    @Input()
    pdfInfoUrl: string = '';
    /**
     * The authorization token to retrieve signature info
     */
    @Input()
    token: string = '';

    // Used in front
    pdfDoc: any;
    item: any;
    signaturesTab: any;
    signaturesCount: any;
    error = {
        error: false,
        msg: ''
    };
    pages: any;
    activeSignature: any;

    // private fields
    private pageNumPending = null;
    private renderingPages: boolean[] = [];
    private pageNum = 0;
    private scales = ['auto', 0.5, 0.75, 1, 1.25, 1.5, 2, 3, 4];
    private scaleIndex = 0;
    private scale;
    private spinnerRunning = false;
    private endReached = false;
    private pdfInfos;
    private dateFormat = 'dd/MM/yyyy HH:mm:ss Z';
    private showSignature = false;
    private isInit = true;


    ngOnChanges(changes) {
        //refresh all value when input change (new document)
        // Used in front
        this.pdfDoc = undefined;
        this.item = undefined;
        this.signaturesTab = undefined;
        this.signaturesCount = undefined;
        this.error = {
            error: false,
            msg: ''
        };
        this.pages = undefined;
        this.activeSignature = undefined;

        // private fields
        this.pageNumPending = null;
        this.renderingPages = [];
        this.pageNum = 0;
        this.scales = ['auto', 0.5, 0.75, 1, 1.25, 1.5, 2, 3, 4];
        this.scaleIndex = 0;
        this.scale = undefined;
        this.spinnerRunning = false;
        this.endReached = false;
        this.pdfInfos = undefined;
        this.dateFormat = 'dd/MM/yyyy HH:mm:ss Z';
        this.showSignature = false;
        this.isInit = true;

        this.downloadPdf();
        this.downloadPdfInfos();

    }

    // Used in front

    /**
     * Displays previous page.
     */
    onPrevPage() {
        if (this.pageNum <= 1) {
            return;
        }
        this.scrollToPage(this.pageNum - 1);
    }

    /**
     * Displays next page.
     */
    onNextPage() {
        if (this.pageNum >= this.pdfDoc.numPages) {
            return;
        }
        this.scrollToPage(this.pageNum + 1);
    }

    /**
     * Change the page with the input field
     */
    updatePage(event) {
        if (event.which === 13) {
            var targetPage = $('#pageNumber').val()!;
            console.log('Request to go to page ' + targetPage, event);
            if (targetPage > 0 && targetPage <= this.pdfDoc.numPages) {
                this.scrollToPage(+(targetPage));
            }
        }
    }

    /**
     * Zoom out
     */
    zoomOut() {
        const that = this;
        if (this.scales[this.scaleIndex] === 'auto') {
            let newScales = Array.from(this.scales);
            newScales = Array.from(this.scales).filter(function (s) {
                return s === 'auto' ? false : s < that.scale;
            });
            let closestScale = Math.max.apply(null, newScales as number[]);
            this.scaleIndex = this.scales.indexOf(closestScale);
        } else {
            if (this.scaleIndex <= 1) {
                return;
            }
            this.scaleIndex--;
        }
        this.pages.forEach(function (element) {
            that.queueRenderPage(element.value);
        });
    }

    /**
     * Zoom in
     */
    zoomIn() {
        const that = this;
        if (this.scales[this.scaleIndex] === 'auto') {
            let newScales = Array.from(this.scales);
            newScales = newScales.filter(function (s) {
                return s === 'auto' ? false : s > that.scale;
            });
            let closestScale = Math.min.apply(null, newScales as number[]);
            this.scaleIndex = this.scales.indexOf(closestScale);
        } else {
            if (this.scaleIndex >= this.scales.length - 1) {
                return;
            }
            this.scaleIndex++;
        }
        this.pages.forEach(function (element) {
            that.queueRenderPage(element.value);
        });
    }

    /**
     * Selected zoom
     */
    zoomSelect() {
        this.scaleIndex = (<HTMLSelectElement>document.getElementById('scaleSelect')).selectedIndex;
        const that = this;
        this.pages.forEach(function (element) {
            that.queueRenderPage(element.value);
        });
    }

    /**
     * Show signatures panel
     */
    toggleSignaturePanel() {
        if (this.showSignature) {
            this.closeSignaturePanel();
        } else {
            this.showSignature = true;
            $('#signaturesPanel').css('transform', 'translateX(310px)');
        }
    }

    /**
     * Download
     */
    download() {
        console.debug("download url = ", this.downloadUrl)
        this.http.get(this.downloadUrl, {
            headers: {
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            },
            responseType: 'blob'
        }).subscribe((response) => {
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(response);
            link.download = this.pdfName + '.pdf';
            link.click();
        })
    }

    openCertificateDialog(signature) {
        const certificatePopup = this.modalService.open(CertificatePopupComponent, {
            size: 'lg',
            centered: true
        });
        certificatePopup.componentInstance.activeSignature = signature;
    }

    updatePageNumberOnScroll() {
        if (!this.pageNum) {
            return;
        }
        var parentRect = document.getElementById('pdfJsContainer')!.getBoundingClientRect();
        var elemRect = document.getElementById('canvas' + this.pageNum)!.getBoundingClientRect();

        // check if end of document is reached
        if (this.pageNum === this.pdfDoc.numPages // if last page
            && elemRect.top + elemRect.height < parentRect.top + parentRect.height + 20 // and last page's bottom is reached
            && !this.endReached) { // end not reached yet
            $('#pdfJsContainer').trigger('endReached');
            this.endReached = true;
            console.log('end of file reached');
            this.shared.broadcast(SbxEvents.DOCUMENT_FULLY_READ)
        }

        // scroll down
        if (elemRect.top + elemRect.height < parentRect.top + parentRect.height / 2) {
            this.pageNum = this.pageNum + 1;
            // Update page counters
            $('#pageNumber').val(this.pageNum);
        }
        // scroll up
        else if (elemRect.top > parentRect.top + parentRect.height / 2) {
            this.pageNum = this.pageNum - 1;
            // Update page counters
            $('#pageNumber').val(this.pageNum);
        }

    }

    /**
     * Set a signature active when the signature is clicked
     * @param event
     */
    onCanvasClick(event) {
        var elem = $('#' + event.target.id);
        var pageClicked = event.target.id.replace('annotationLayer', '');


        var xRatio = (event.pageX - elem.offset()!.left) / elem.width()!;
        var yRatio = (event.pageY - elem.offset()!.top) / elem.height()!;

        var PDF_WIDTH = 1190, PDF_HEIGHT = 1682;

        var signatureClicked = false;
        for (var i = 0; i < this.signaturesTab.length; i++) {
            var signature = this.signaturesTab[i];
            if (+pageClicked === signature.page) {
                var sigPos = signature.coord;
                if (sigPos[0] / PDF_WIDTH <= xRatio && xRatio <= (sigPos[0] + sigPos[2]) / PDF_WIDTH &&
                    sigPos[1] / PDF_HEIGHT <= yRatio && yRatio <= (sigPos[1] + sigPos[3]) / PDF_HEIGHT) {
                    signature.active = true;
                    this.activeSignature = signature;
                    signatureClicked = true;
                    this.toggleSignaturePanel();
                    break;
                } else {
                    signature.active = false;
                    this.activeSignature = undefined;
                }
            }
        }
        if (!signatureClicked && this.showSignature) {
            this.toggleSignaturePanel();
        }
    }

    /**
     * If another page rendering in progress, waits until the rendering is
     * finished. Otherwise, executes rendering immediately.
     */
    queueRenderPage(num) {
        console.log('queueRenderPage page ' + num);
        if (this.renderingPages[num - 1]) {
            this.pageNumPending = num;
        } else {
            this.renderPage(num);
        }
    }

    // Others


    /**
     * Scroll to requested page and update the model.
     * @param pageToGo The page to scroll to
     */
    private scrollToPage(pageToGo) {
        console.log('scrollToPage', pageToGo);
        // Update page counters
        this.updatePageIndex(pageToGo);
        //Update front to go to the correct page
        var parent = document.getElementById('pdfJsContainer');
        var elem = document.getElementById('canvas' + this.pageNum);
        if (parent && elem) {
            parent.scrollTop = elem.getBoundingClientRect().top - parent.getBoundingClientRect().top + parent.scrollTop;
        }
    }

    /**
     * Update the scope and the visual form value
     * @param pageIndex The page to display
     */
    private updatePageIndex(pageIndex) {
        this.pageNum = pageIndex;
        // pageNum is not bind with angular to avoid mismatch with scrolling and wrong input data
        $('#pageNumber').val(this.pageNum);
    }


    private renderPage(num) {
        console.log('Rendering PDF page ' + num);
        // num starts at 1
        this.renderingPages[num - 1] = true;

        const that = this;
        this.pdfDoc.getPage(num).then(function (page) {
            // device pixel ratio for Ipad
            let canvas = <HTMLCanvasElement>document.getElementById('canvas' + num);
            let ctx = canvas.getContext('2d');
            ctx!.scale(1, 1);

            // scale
            (<HTMLSelectElement>document.getElementById('scaleSelect')).selectedIndex = that.scaleIndex;
            that.scale = that.scales[that.scaleIndex];
            var viewport;
            if (that.scale === 'auto') {
                // if scale is auto, computes it then find the closest scale value allowed (that is lower)
                canvas.style.width = '100%';
                canvas.width = canvas.offsetWidth;
                that.scale = canvas.width / page.getViewport(1.0).width;
                let lower = 0.5;
                that.scales.forEach(function (z) {
                        if (z < that.scale) {
                            lower = z as number;
                        }
                    }
                );
                that.scale = lower;
            }
            // then displays it with the correct scale
            canvas.style.width = 'auto';
            viewport = page.getViewport(that.scale);
            canvas.height = viewport.height;
            canvas.width = viewport.width;

            let renderContext = {
                canvasContext: ctx,
                viewport: viewport
            };
            let renderTask = page.render(renderContext);

            // Wait for rendering to finish
            renderTask.promise.then(function () {
                that.renderingPages[num - 1] = false;
                if (that.pageNumPending !== null) {
                    // New page rendering is pending
                    that.queueRenderPage(that.pageNumPending);
                    that.pageNumPending = null;
                }

                if (that.spinnerRunning) {
                    that.spinnerService.hide('spinner-pdf');
                    that.spinnerRunning = false;
                }
                let parameters = {intent: 'display'};
                return page.getAnnotations(parameters);
            }).then(function (annotationData) {
                if (annotationData.length === 0) {
                    return;
                }
                let jCanvas = $('#canvas' + num);
                let annotationLayer = $('#annotationLayer' + num);

                // Clear HTML for annotation layer and show
                annotationLayer.html('').show();

                // Assign the CSS created to the annotation-layer element
                annotationLayer.css({
                    // @ts-ignore
                    left: jCanvas.offsetLeft + 'px',
                    // @ts-ignore
                    top: jCanvas.offsetTop + 'px',
                    height: canvas.clientHeight + 'px',
                    width: canvas.clientWidth + 'px'
                });

                (window as any).global.PDFJS.AnnotationLayer.render({
                    viewport: viewport.clone({dontFlip: true}),
                    div: annotationLayer.get(0),
                    annotations: annotationData,
                    page: page
                });
            });
        });
    };

    private loadPdf(blob) {
        this.spinnerService.show("spinner-pdf-loading");
        var url = window.URL.createObjectURL(blob);

        var loadingTask = (window as any).global.PDFJS.getDocument(url); // eslint-disable-line

        const that = this;
        loadingTask.promise.then(function (pdf) {
            console.log('PDF loaded. ' + pdf.numPages + ' pages available.');
            that.pdfDoc = pdf;
            let array = new Array(pdf.numPages);
            that.renderingPages = new Array(pdf.numPages);
            for (let i = 0; i < array.length; i++) {
                // MTSSIGNBOX-1435: "crappy" solution to not be blocked by the dom reuse enhancement of angular : https://code.angularjs.org/1.7.9/docs/api/ng/directive/ngRepeat
                array[i] = {'value': i + 1};
                that.renderingPages[i] = false;
            }
            that.pages = array;
            that.updatePageIndex(1);

            if (that.isInit) {
                that.pages.forEach((page) => {
                    that.queueRenderPage(page.value);
                })
                that.isInit = false;
            }
        }).finally(() => {
            that.spinnerService.hide("spinner-pdf-loading");
        });
    };

    private downloadPdf() {
        this.spinnerService.show('spinner-pdf');
        this.spinnerRunning = true;
        this.http.get(this.downloadUrl, {
            headers: {
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            },
            responseType: 'blob'
        }).subscribe({
            next: response => {
                if (response) {
                    this.loadPdf(response);
                } else {
                    this.error = {
                        error: true,
                        msg: 'Le document n\'a pas pu être chargé'
                    };
                }
            },
            error: error => {
                console.log('Error ' + error.status + ' : Can\'t load the pdf data');
                this.error = {
                    error: true,
                    msg: 'Le document n\'a pas pu être chargé'
                };
            },
            complete: () => {
                this.spinnerRunning = false;
                this.spinnerService.hide('spinner-pdf');
            }
        })
    };


    private downloadPdfInfos() {
        console.log('download pdf infos');
        const that = this;
        $.ajax({
            url: this.pdfInfoUrl + "/" + that.pageNum,
            cache: false,
            type: 'GET',
            beforeSend: function (xhr) {
                xhr.setRequestHeader('Authorization', 'Bearer ' + that.token);
            },
            success: function (data) {
                console.log('pdf info retrieved')
                that.pdfInfos = data;
                if (that.pdfInfos.success) {
                    that.signaturesTab = that.pdfInfos.data.signatures;
                    console.log('SignaturesTab : ', that.signaturesTab);
                    that.signaturesTab.forEach(function (signature) {
                        // get the name of the signer
                        signature.dn = that.parseDn(signature.name);
                        if (signature.dn.cn.includes('[') && signature.dn.cn.includes(']')) {
                            signature.shortCn = signature.dn.cn.substr(0, signature.dn.cn.indexOf('[') - 1);
                        } else {
                            signature.shortCn = signature.dn.cn;
                        }
                        signature.timestamp = that.datePipe.transform(new Date(signature.timestamp), that.dateFormat);
                        signature.creationDate = that.datePipe.transform(new Date(signature.creationDate), that.dateFormat);
                        signature.expirationDate = that.datePipe.transform(new Date(signature.expirationDate), that.dateFormat);
                    });
                    that.signaturesCount = that.pdfInfos.data.signatures.length;
                }
            },

            error: function () {
                console.log('error pdf info')
                that.pdfInfos = [{
                    'id': 'failedDocument',
                    'pageCount': 1,
                    'pages': [{
                        'index': 1,
                        'height': 1682,
                        'link': 'error',
                        'width': 1190,
                        'data': null
                    }],
                    'link': null,
                    'data': null,
                    'signatures': []
                }];
            }
        });
    };

    private parseDn(dn) {
        var parsedDn = ldapjs.parseDN(dn).rdns;
        var outputDn = {};
        parsedDn.forEach(function (rdn) {
            for (var field in rdn.attrs) {
                outputDn[field] = rdn.attrs[field].value;
            }
        });
        return outputDn;
    };

    private closeSignaturePanel() {
        this.showSignature = false;
        $('#signaturesPanel').css('transform', '');
    };

}
